'use client';

import { SelectionCard } from '@jouzen/ecom-components/v3/SelectionCard';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useFeatureGate } from '@statsig/react-bindings';
import { useTranslations } from 'next-intl';

import { useAddOnBundleContext } from '@/app/[locale]/meta/_contexts/AddOnBundleProvider';
import MembershipSelectionEnum from '@/app/enums/MembershipSelectionEnum';
import useCurrency from '@/app/hooks/useCurrency';

const OneYearMembershipSection = () => {
  const isUS = useFeatureGate('usa_only').value;
  const t = useTranslations();
  const { currencyCode } = useCurrency();
  const { oneYearMembershipData, membershipSelection, onMembershipSelection } =
    useAddOnBundleContext();

  const oneYearMembershipPrice = oneYearMembershipData?.price?.amount ?? 69.99;

  return (
    <div
      className="border-b border-sandstone-500/50 pb-3 md:w-[46%] md:border-b-[0px] md:pb-1"
      data-cy="membership-section"
    >
      <Typography
        className="pb-3 text-xl font-medium md:pb-4"
        data-cy="one-year-title"
      >
        {t('bundle_modal_one_year_title')}
      </Typography>
      <Typography
        className="pb-5 text-base font-medium"
        data-cy="bundle-membership-subtitle"
      >
        {t(
          isUS
            ? 'bundle_modal_one_year_subtitle_hsa'
            : 'bundle_modal_one_year_subtitle',
        )}
      </Typography>
      <SelectionCard
        data-cy="bundle-membership-one-year"
        cardSelected={membershipSelection === MembershipSelectionEnum.OneYear}
        currencyCode={currencyCode}
        price={oneYearMembershipPrice}
        title={t('12_months_prepaid')}
        onCheckBoxClick={() =>
          onMembershipSelection({
            membershipInput: MembershipSelectionEnum.OneYear,
          })
        }
      />
      <Typography className="mt-6 italic">
        {t('add_ons_one_year_prepaid_copy')}
      </Typography>
    </div>
  );
};

export default OneYearMembershipSection;
